<template>
    <b-card>
        <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
         <div slot="header">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
            {{text.formRegisterUser}}
          <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">{{text.docs}}</small>
            </a>
          </div>
        </div>
        <b-row>
            <b-col sm="12">
                <alert-success :redirectName="'userManagement-home'" :show="successMessage != ''"> {{ successMessage }} </alert-success>
                <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>

                <!-- Thumbnail -->
                <b-form-group>
                    <div class="text-center">
                    <img class="thumbnail" :src="previewThumbnail" alt="Thumbnail">
                    </div>
                    <b-input-group>
                    <div class="custom-file">
                        <input type="file" class="custom-file-input" @change="changeThumbnail">
                        <label class="custom-file-label"> {{ form.thumbnail.name || text.chooseThumbnailFile + ' 50x50' }} </label>
                    </div>
                    <b-button variant="outline-secondary"
                      @click="previewThumbnail = '/images/avatars/default.jpg'; thumbnail = {}; form.isDefaultThumbnail = true">
                    {{text.setDefault}}
                    </b-button>
                    </b-input-group>
                </b-form-group>

                <!-- Username -->
                <b-form-group>
                    <label >{{text.usernameEmail}}</label>
                    <b-input-group>
                        <b-input :readonly="isUpdate" :state="feedback(fieldErrors.username)" v-model="form.username" :placeholder="text.pleaseInsertUsernameOrEmail"></b-input>
                    </b-input-group>
                </b-form-group>

                <!-- Fullname -->
                <b-form-group>
                    <label >{{text.fullname}}</label>
                    <b-input-group>
                        <b-input :state="feedback(fieldErrors.fullname)" v-model="form.fullname" :placeholder="text.pleaseInsertFullname"></b-input>
                    </b-input-group>
                </b-form-group>

                <!-- Permission -->
                <b-form-group>
                  <label>{{text.permission}}</label>
                  <v-select v-model="form.permission" multiple :options="permissionList" :placeholder="text.pleaseSelectPermissionsOfUser"></v-select>
                </b-form-group>

                <!-- Status -->
                <b-form-group>
                    <label>{{text.status}} : </label>
                    <b-form-radio-group
                    class="ml-2"
                    size="sm"
                    button-variant="outline-secondary"
                    :options="[{ text: text.active, value: 'active'}, { text: text.suspend, value: 'suspend'}]"
                    v-model="form.status"
                    buttons
                  ></b-form-radio-group>
                </b-form-group>

              <div v-show="!isUpdate">
                <!-- register Type -->
                <b-form-group>
                    <label>{{text.registerType}} : </label>
                    <b-button class="ml-2" size="sm" variant="secondary" @click="registerType=!registerType"> {{registerTypeText}} </b-button>
                </b-form-group>

                <transition name="custom-classes-transition"
                enter-active-class="animated fadeInDown"
                >
                <div v-if="!registerType">
                  <!-- Password -->
                  <b-form-group>
                      <label>{{text.password}}</label>
                      <b-input-group>
                          <b-input type="password" :state="feedback(fieldErrors.password)" v-model="form.password" :placeholder="text.pleaseInsertPassword"></b-input>
                      </b-input-group>
                  </b-form-group>

                  <!-- Confirm Password -->
                  <b-form-group>
                      <label>{{text.confirmPassword}}</label>
                      <b-input-group>
                          <b-input type="password" :state="feedback(fieldErrors.confirmPassword)" v-model="form.confirmPassword" :placeholder="text.pleaseInsertConfirmPassword"></b-input>
                      </b-input-group>
                  </b-form-group>
                </div>
                </transition>
              </div>
            </b-col>
        </b-row>
        <div slot="footer">
          <b-button @click="$router.go(-1)" class="mr-2" size="sm" variant="secondary">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            {{text.back}}
          </b-button>
          <b-button :disabled="!isActive" @click="save" class="mr-2" type="submit" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            {{text.save}}
          </b-button>
          <b-button v-show="isUpdate" :disabled="!isActive" v-b-modal.confirmDelete class="mr-2" type="submit" size="sm" variant="danger">
            <i class="fa fa-dot-circle-o"></i>
            {{text.delete}}
          </b-button>
          <alert-confirm
            :id="'confirmDelete'"
            @confirm="deleteUser">
            confirm to delete ?
          </alert-confirm>
        </div>
    </b-card>
</template>

<script>
import AlertSuccess from '../../components/alert/AlertSuccess';
import vSelect from 'vue-select';
import Loading from '../../components/Loading';
import AlertConfirm from '../../components/alert/AlertConfirm';
import { textUser } from '@/assets/utils/language';

export default {
  data () {
    return {
      id: null,
      successMessage: '',
      errorMessage: '',
      previewThumbnail: '/images/avatars/default.jpg',
      fieldErrors: {},
      form: {
        username: '',
        status: 'active',
        permission: [],
        password: null,
        confirmPassword: null,
        thumbnail: {},
        isDefaultThumbnail: true
      },
      registerType: true, // true = firebase, false = directly
      isActive: true,
      isLoading: false,
      permissionList: [],
      text: {}
    };
  },
  methods: {
    changeThumbnail (e) {
      const files = e.target.files || e.dataTransfer.files;
      this.form.thumbnail = files[0];
      this.form.isDefaultThumbnail = false;
      this.previewThumbnail = URL.createObjectURL(this.form.thumbnail);
    },
    handleError (error) {
      if (error.response) {
        this.errorMessage = error.response.data.data.map(value => value.msg).join(', ');
      } else {
        this.errorMessage = error.response || error.message;
      }
    },
    deleteUser () {
      this.isActive = false;
      this.isLoading = true;
      this.axios.delete(process.env.VUE_APP_ACCESS_CONTROL_URL + '/user/' + this.id)
        .then(response => {
          this.isLoading = false;
          this.successMessage = 'Delete already';
        })
        .catch(error => {
          this.isActive = true;
          this.isLoading = false;
          this.handleError(error);
        });
    },
    save () {
      this.errorMessage = '';
      this.isActive = false;
      this.isLoading = true;
      const formData = new FormData();
      formData.append('fullname', this.form.fullname);
      formData.append('type', this.registerTypeText.toLowerCase());
      formData.append('status', this.form.status);
      formData.append('permission', this.form.permission);
      formData.append('thumbnail', this.form.thumbnail);
      if (null == this.id) { // create
        formData.append('username', this.form.username);
        formData.append('password', this.form.password);
        formData.append('confirmPassword', this.form.confirmPassword);
        this.axios.post(process.env.VUE_APP_ACCESS_CONTROL_URL + '/user/register', formData)
          .then(response => {
            this.isLoading = false;
            this.successMessage = 'Create user success! ';
          })
          .catch(error => {
            this.isActive = true;
            this.isLoading = false;
            this.handleError(error);
          });
      } else { // update
        this.axios.patch(process.env.VUE_APP_ACCESS_CONTROL_URL + '/user/' + this.id, formData)
          .then(response => {
            this.isLoading = false;
            this.successMessage = 'Update user success !';
          })
          .catch(error => {
            this.isActive = true;
            this.isLoading = false;
            this.handleError(error);
          });
      }
    },
    getData () {
      const username = this.$route.params.username;
      if (username) {
        this.isActive = false;
        this.isLoading = true;
        this.axios.get(process.env.VUE_APP_ACCESS_CONTROL_URL + '/user/' + username)
          .then(response => {
            const data = response.data.data;
            if (data.user.id) {
              this.id = data.user.id;
              this.form.username = data.user.username;
              this.form.fullname = data.user.fullname;
              this.form.permission = data.user.permission;
              this.form.status = data.user.status || 'suspend';
              this.registerType = 'firebase' === data.user.type;
              this.previewThumbnail = data.user.thumbnail || '/images/avatars/default.jpg';
            } else {
              this.$router.push({ name: 'userManagement-create' });
            }
          })
          .catch(error => {
            this.handleError(error);
          })
          .finally(() => {
            this.isActive = true;
            this.isLoading = false;
          });
      }
    },
    getPermissionList () {
      this.permissionList = [];
      this.axios.get(process.env.VUE_APP_ACCESS_CONTROL_URL + '/permission')
        .then(response => {
          const data = response.data.data;
          if (data) {
            for (const permission of data.permissions) {
              this.permissionList.push(permission.name);
            }
          }
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    setDefault () {
      this.form = {
        username: '',
        status: 'active',
        permission: [],
        password: null,
        confirmPassword: null
      };
      this.registerType = 'firebase';
      this.id = null;
    }
  },
  computed: {
    feedback () {
      return data => {
        if (!data) {
          return null;
        } else {
          return data.isCorrect;
        }
      };
    },
    registerTypeText () {
      return this.registerType ? 'Firebase' : 'Directly';
    },
    isUpdate () {
      return null != this.id;
    }
  },
  mounted () {
    this.getPermissionList();
    this.getData();
    this.text = textUser(this.$language);
  },
  watch: {
    '$route' (to, from) {
      this.setDefault();
      this.getData();
    },
    $language: function () {
      this.text = textUser(this.$language);
    }
  },
  components: {
    AlertSuccess,
    AlertConfirm,
    'v-select': vSelect,
    'app-loading': Loading
  }
};
</script>

<style scoped>
.thumbnail{
      width: auto;
      max-height: 40px;
      -webkit-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      margin-bottom: 5px;
    }
</style>
